import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { sortedApi } from 'gwx-voyager-components';
import rootReducer from './reducers';

const configureStore = (preloadedState) => createStore(
	rootReducer, preloadedState, applyMiddleware(thunkMiddleware, sortedApi)
);

export default configureStore;
